import { SET_NUMBER_OF_PDF } from './types'

export const setNumberOfPdf = payload => ({
    type: SET_NUMBER_OF_PDF, payload
})


// WEBPACK FOOTER //
// ./src/redux/pdf/actions.js